import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GlobalErrorReason } from '../../core/session-data';

@Component({
  standalone: false,
  templateUrl: './error-page.component.html'
})

export class ErrorPageComponent {

  public reason: GlobalErrorReason;
  private supportedReasons = ['401', '500'];

  constructor(
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe( params => {

      this.reason = params.reason &&
        this.supportedReasons.includes(params.reason.toString())
          ? params.reason
          : 0;

    });
  }

}
